export interface Writing {
  id: string;
  title: string;
  tags: string[];
  publishedAt: string;
  image?: string;
  content: string;
}

export const writings: Writing[] = [
  {
    id: 'become-a-professional-gambler',
    title: 'Become a professional gambler',
    tags: ['mindset'],
    publishedAt: '2025-10-26',
    image: '/professional-gambler.jpeg',
    content: `i think life is about taking the minimal amount of super high-conviction bets that have the best upside.

you have minimal resources, so you need to be able to concentrate as much of what you have into one single big bet. 

but most of the people are scared to even play. "its too risky", you say. 

the only thing you see as a risk is self-doubt, which at the end of the day is an ego thing. you're scared that people will look at you and think about you as a failure. but so what? who tf cares? 

you're so much more scared of what you will look like if you fail instead of failing. 

get rid of that ego. 

and the maths are on my side at this: statistically you cant fail if you dont stop trying. only if you decide to throw the towel into the ring. if you decide to raise that white flag. to admit you quit. 

but as long as you keep going after it, you havent failed. 

self-doubt can seem like an ocean, but when you actually step inside you see that its a couple of cm deep. 

poker has taught me so much about life and taking the right type of risk at the right time. and that you can win with terrible cards and lose with really good ones. its all about the way you play the game.

i think being able to spot good opportunities when they arise is a really important skill. i think it combines quick math (calculus) + clear thinking very well. being good at both will get you far in life. 

but this is the skill most people suck at. most of the times they are wrong about what is risky and what are their chances of winning. but you cant win if you dont play. sometimes the cannon wins the whole pot. 

but back to the beef. 

in general risk means an unwanted event (or the cause for that) that may or may not occur (Stanford Encyclopedia)

so by definition, someone who would say that dropping out of uni and starting your own venture is risky, would be wrong. 

and obviously you could argue that if the reason why i dropped out does not succeed, its the occurrence of the unwanted event. 

but we also need to define the upside: the wanted event. 

and here comes the fun part of being really optimistic up to being delusional. 

you have no single wanted event. you can have 1000 different wanted events, some better than others, but at the end of the day‚ having 1000 wanted events vs 1 unwanted means your chances of succeeding are actually very high. 

so i have nothing to lose. whatever happens, i've won. 

from first principles, i wouldnt do anything with my diploma, i wont lose my apartment (thanks kela), i would have enough money for food etc. 

so the downside is minimised but the upside is infinite? seems like you would be just either a) bad at spotting opportunities or b) afraid of looking like a failure. 

and i know this is not how everyone thinks. 99% of the people want to grind the corporate ladder. but id hate that. 

dont get me wrong, i wouldnt recommend dropping out for most of the people. university is good for them. 

either way, succeeding 100% or 50% or 25%, i'd learn a ton and if i get knocked down, i will stand up again and do something else. 

then lastly, some of you try to mitigate the risk by doing a little bit of this and a little bit of that. firing to multiple targets at the same time and missing all of them. you're not a hedge fund.  

using this method you will probably lose to the market. what you need to do is find the most interesting thing you can do and see yourself spending the rest of your life and commit to it. 

like Elon said: "i dont care if all my eggs are in one basket, as long as im the one holding it"

be all in.

- T`
  },
  {
    id: 'there-is-no-such-thing-as-impossible',
    title: 'There is no such thing as "impossible"',
    tags: ['mindset'],
    publishedAt: '2025-09-05',
    content: `whenever i hear someone saying "that's impossible", the little kid inside of me gets very excited. 

by definition term impossible refers to something being unattainable - something that can't be done. it indicates that it's so far away, that it can't be reached. 

but that type of thinking is very wrong from the first principles. see us humans, our life is finite - so we tend to think everything else around is finite as well. because why wouldn't they be? 

but life is not finite, the world would keep moving on even if i'd disappear today. we would still make new advancements in tech, science and other fields. 

i fairly think sporting and entrepreneurship go pretty hand in hand regarding what it takes to become the best, or to break the barrier of "impossible".

sporting immortality does not come easily. there are challenges that seem insurmountable, times that can't be beaten, distances that cannot be achieved - things that every normal human being tells you is impossible. 

and then suddenly, it happens. the barrier gets broken. history is made. 

but to do that, to break new ground, it takes something very special. 

it takes someone to be so delusional in their own ability that they don't see any reasons why they couldn't do it. it takes someone to understand that their potential is boundless. 

and then there is the work to be done. i can't really say, which one is harder - to actually believe that you can achieve something, or to show up everyday and progress towards it. but the recipe is simple.

and the same principles apply to entrepreneurship. 

i can fairly say, that probably everyone were told in their childhood that they could do anything. to believe in themselves. and for some reason most of us lose that belief as we grow older. the system changes us. it rewards for mediocrity. 

you are the sum of the people around you, and if everyone else speaks and thinks that impossible things are unachievable - that they actually are impossible, you will start to believe it.

but the best thought you can have is "why couldn't i?"

someone smart once said that everything around you was made by ordinary people that weren't smarter than you. they just had extraordinary self belief to think that the "impossible" was possible. 

and the problem with most people is that they spent their whole life thinking there are exact rules and frameworks that need to be followed. 

but there really isn't. 

im super happy to be surrounded by people that don't see life as finite. 

life is a continuous spectrum, and everything we today think is "impossible" will be achieved some day. 

and my last question for you is: why not? 

happy entrepreneurs day.

- T
      `
  },
  {
    id: 'control-of-focus',
    title: 'Control of Focus',
    tags: ['founders way'],
    publishedAt: '2025-07-13',
    content: `I believe that a successful startup is built on three fundamental pillars: direction, speed and focus.

They all matter, direction is the grand vision you are taking part on, and obviously speed should be maximised. But these two don't matter if you aren't actually focused on the most important things.

If you focus on the wrong things with a maximised speed, you end up doing work that wasn't actually important. It might be even irrelevant to your company.

And it's usually ok to be wrong if you iterate quickly, but that means you have to be able to give self-critique, which most people find hard.

Focus is a force multiplier on work.

I highly believe that 98% of the work we do simply doesn't need to be done.

It is highly valuable and underappreciated to think about what to focus on. It is much more important to focus on the right thing than to work for many hours.

I've found Sam Altman's prioritization algorithm pretty good:
1. Make sure to get important shit done
2. Don't waste time on stupid shit
3. Make a lot of lists

The decision stack should be something like:

Grand vision → yearly plan → quarterly bets → weekly → daily top three.

But to know what to write on those lists, you need to think independently about:

What is your actual goal?
What are the next steps to getting there?

And then execute those steps. If you don't, you might as well go play volleyball.

Once you get this figured out, be unstoppable about getting these steps accomplished quickly. Then step back, take a look where you're going, ok direction is good, and figure out the next steps.

Also, try to become a really good delegator on tasks that need to be done but don't need your attention.

Good note to mention, good focus means you need to be ruthless about saying no to stuff that doesn't align with your priorities. I am pretty sure some people think of me as a rude person when replying to their emails or wishes.

I try to keep a funeral list of killed ideas and tasks and go back to them once in a while to see if I had miscalculated something.

I personally know that I can't focus on things I don't care about or don't like. It's painful to carry a bag of milk to the mountains if you're lactose intolerant.

So try to find something you really care about and have a unique view on.

I've seen that the best founders have strong beliefs about the world, found a niche from that world that tickles their pickle and then put all in on that grand vision.

Also, don't fall into the trap of productivity porn. I know a lot of people who spend too much time thinking of optimizing their systems and habits instead of just asking if they're working on the right problem.

But some things help me focus, and it is mostly related to brain activity.

Having a clear and sharp mind helps a lot, and here are some things I've found useful:

• Eat right. I try to avoid big amount of carbs and do intermittent fasting.
• Knowing your inflammation is highly beneficial
• Do aerobic + strength training
• Write your thoughts on paper and go back to them
• Drink a lot of water
• Do meditation in any type or form. I prefer to run without music
• Eat vitamins, and take creatine
• Time block your calendar
• Remove notifications from apps
• Find music that turns into background noise, I've found EDM works well for me

- T`

  }
];
